<script setup>

// Import bev.js
//import '../utils/bev.js'
import { asset_host } from '@/settings/settings'
import { useRoute, useRouter } from 'vue-router'
import { onMounted, onUpdated, ref, watch } from 'vue'
import { useDataStore } from '@/stores/data.store'
import { useStateStore } from '@/stores/state.store'
import { useBevRenderer } from '@/Composables/use-bev-renderer';

const bevRenderer = useBevRenderer();
const { _initOverlays, _showProduct } = bevRenderer;

const props = defineProps({
  room_id: {
    type: String,
    default: null
  }
})

const products = ref(null)
const dataStore = useDataStore()
const route = useRoute()


//const roomImage = (props.room_id == 'riton') ? '/home/img/rooms/riton_render_v2.webp' : '/home/img/rooms/lara-raum.webp'
const roomImageSuffix = (props.room_id == 'yana') ? '-v2' : ''
const roomImage = asset_host + 'bev-' + props.room_id + roomImageSuffix + '.webp'
const room_id = props.room_id
const state = useStateStore()


onMounted(() => {
    //alert('ROOM: ' + route.params.room_id);
    //initBev();

    // Load Products (Overlays will be rendered by Vue Components)
    dataStore.getRoomData(room_id).then((response) => {
      console.log(response.products)
      products.value = response.products

      // Display Product on load (if product handle is part of URL)
      if (route.query.product) {
        showProduct(route.query.product);
        return;

        // Find product with product.handle == route.query.product
          for (const key in products.value) {
            if (products.value[key].handle == route.query.product) {
              bevRenderer.showProduct(products.value[key].handle, products.value[key].shopify_id);
              return;
            }
          }
      }
    });
});

// Watch for changes to the product query parameter and update displayed product accordingly
watch(
  () => route.query.product,
  (newProduct, oldProduct) => {

    showProduct(newProduct);
        return;

    if (products.value && newProduct) {
      for (const key in products.value) {
        if (products.value[key].handle == newProduct) {
          bevRenderer.showProduct(products.value[key].handle, products.value[key].shopify_id);
          return;
        }
      }
    }
  }
);

// Add Seeker Overlay Events
onUpdated(() => {
  //console.log('BEV Image Updated ' + room_id);
  // Activate Seeker Overlays
  bevRenderer.initOverlays(products.value)
})


const showProduct = (productHandle) => {
  if (products.value && productHandle) {
      for (const key in products.value) {
        if (products.value[key].handle == productHandle) {
          bevRenderer.showProduct(products.value[key].handle, products.value[key].shopify_id);
          return;
        }
      }
    }
    state.popProduct();
}
    


// Wait until DOM is rendered

</script>
<template>

  <div class="image-wrapper">
      <div class="image-container">
          <img :src="roomImage" alt="Room Image" id="viewer-image">
      </div>
      <div id="product_overlays" class="overlays" style="position: absolute">
        <div v-for="product in products" :key="product" class="overlay" :data-handle="product.handle" :data-shopify_id="product.shopify_id" :data-tooltip="product.name" :data-price="product.price" :style="'left: ' + product.xpos + '; top: ' + product.ypos + ';'">
          <svg class="svg-area" width="150px" height="150px" viewBox="0 0 400 400">
            <g transform="translate(200,200)">
                <circle id="radar" cx="0" cy="0" r="30" fill="rgba(255, 255, 255, 0.5)"></circle>
                <circle id="core" cx="0" cy="0" r="20" fill="#ffffff"></circle>
            </g>
          </svg>
        </div>
      </div>
  </div>
  <div id="seeker-box" class="seeker-box">
    <div class="seeker-left"></div>
    <div class="seeker-right">
        <div id="seeker-box-title" class="seeker-title"></div>
        <div id="seeker-box-price" class="seeker-price"></div>
    </div>
  </div>

</template>
<style lang="scss" >

.header {
    xxxbackground-color: transparent !important;
    xxxz-index: 3000 !important;
}

.absolute {
  position: absolute;
}

.relative {
  position: relative;
}

.flex {
  display: flex;
}

.header-icon {
  height: 24px;
}

.room {
  position: relative;
  margin-left: 30px;
  margin-right: 30px;
}

.room-image {
  height: 500px;
  overflow-x: auto;
  border-radius: 15px;
  scrollbar-width: thin;
  position: relative;
}

/* Hero Pan */
.room-image img {
  xxwidth: 100%;
  width: 1236px;
  height: 773px;
  xxheight: 500px;
  xxobject-fit: cover;
  object-position: center;
}

.room.hero .creator {
  width: 146px;
  border-radius: 100%;
}

.room-teaser {
  width: 320px;
  height: 260px;
  position: relative;
  margin-bottom: 20px;
}

.room-teaser img.room {
  position: absolute;
  top: 0;
  left: -23px;
  width: 298px;
  height: 200px;
  object-fit: cover;
  object-position: center;
  border-radius: 12px;
  margin-right: 0;
}

.room-teaser.blurred .teaser-pic {
  filter: blur(10px);
  margin-left: -10px;
}

.room-teaser img.corner-overlay {
  position: absolute;
  top: 118px;
  left: 5px;
  object-fit: cover;
  object-position: center;
  border-radius: 12px;
  width: 85px;
}

.room-teaser img.creator-picture {
  position: absolute;
  top: 140px;
  left: -18px;
  width: 85px;
  border-radius: 100%;
}

.room-teaser .name {
  position: absolute;
  text-align: left;
  top: 210px;
  left: 100px;
  font-size: 1.5rem;
  font-weight: 500;
}

.room-teaser .teaser {
  position: absolute;
  text-align: left;
  top: 250px;
  left: 0px;
  font-size: 1rem;
  padding-left: 20px;
  color: #555555;
  font-weight: 300;
  line-height: 1.3rem;
  height: 80px;
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  mask-image: linear-gradient(to bottom, black 60%, transparent 100%);
  -webkit-mask-image: linear-gradient(to bottom, black 60%, transparent 100%);
}

.room-teaser .teaser-more {
  position: absolute;
  bottom: -13px;
  right: 5px;
  color: #777b9d;
  cursor: pointer;
  width: 24px;
  height: 24px;
  transition: transform 0.2s ease;
}
.room-teaser .teaser-more:hover {
  transform: translateY(2px);
}

/* GAMES */
.games {
  margin: 0 auto;
}

.games td + td {
  border-left: 80px solid transparent;
}

@media (max-width: 576px) {
  .games td + td {
    border-left: 20px solid transparent;
  }
}
.game-box {
  /* shadow */
  box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.1);
  border-radius: 20px;
  text-align: center;
  padding: 20px 10px;
  transition: transform 0.3s ease;
}

.game-box:hover {
  transform: translateY(-5px);
}

.game-box .picture img {
  border-radius: 25px;
}

.game-box .name {
  font-size: 16px;
  color: #282c3d;
  font-weight: 600;
  padding: 27px 0px 17px;
}

.game-box .link a {
  border-radius: 25px;
  width: 120px;
  font-weight: 600;
  line-height: 31px;
}

@media (max-width: 466px) {
  .game-box .picture img {
    width: 140px;
  }
}
/* Products */
.product-slider .product-teaser {
  width: 228px;
  height: 300px;
  display: inline-block;
  position: relative;
  padding-top: 34px;
  padding-left: 14px;
  transition: transform 0.3s ease;
}

.product-slider .product-teaser:hover {
  transform: translateY(-5px);
}

.product-slider .product-teaser .background {
  background: white;
  border-radius: 20px;
  width: 100%;
  height: 252px;
  display: inline-block;
  padding: 15px 15px 62px 15px;
}

.product-slider .product-teaser .background img {
  width: 186px;
  height: 100%;
  object-fit: cover;
  object-position: center;
  border-radius: 20px;
}

.product-slider .product-teaser .creator {
  position: absolute;
  top: 0px;
  left: 0px;
  width: 67px;
  border-radius: 100%;
}

.product-slider .product-teaser .price {
  position: absolute;
  bottom: 0px;
  right: 0px;
  font-weight: 600;
}

/* Drawer Panel */
.drawer-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  z-index: 1000;
  opacity: 0;
  visibility: hidden;
  transition: opacity 0.3s ease, visibility 0.3s ease;
}
.drawer-overlay.active {
  opacity: 1;
  visibility: visible;
}

.drawer {
  position: fixed;
  top: 0;
  right: -400px;
  width: 400px;
  height: 100%;
  background: white;
  z-index: 1001;
  transition: right 0.3s ease;
  box-shadow: -4px 0 12px rgba(0, 0, 0, 0.1);
}
.drawer.active {
  right: 0;
}
@media (max-width: 576px) {
  .drawer {
    width: 100%;
    right: -100%;
  }
}

.drawer-header {
  padding: 20px;
  border-bottom: 1px solid #eee;
  display: flex;
  justify-content: flex-end;
}

.drawer-close {
  cursor: pointer;
  padding: 8px;
}

.drawer-content {
  padding: 20px;
}

.drawer-nav {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.drawer-link {
  color: #272b3d;
  text-decoration: none;
  font-size: 1.25rem;
  font-weight: 500;
  padding: 0;
  line-height: 1.25rem;
  margin-top: 0.25rem;
}
.drawer-link:hover {
  color: #5ac8fa;
}

.light-blue-box {
  padding: 12px 20px;
  background-color: rgb(148, 212, 250);
  border-radius: 20px;
  color: white;
}

.bold {
  font-weight: 600;
}

.font-xxl {
  font-size: 2.5rem;
  line-height: 2.5rem;
}

/* Floating Elements */
.floating-element {
  position: absolute;
  pointer-events: none;
}

.floating-box {
  padding: 10px;
  border-radius: 20px;
  box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.1);
}
.floating-box img {
  display: block;
}

.overlay {
  position: absolute;
}

.top {
  top: 20px;
}

.left {
  left: 20px;
}

.bottom {
  bottom: 20px;
}

.right {
  right: 20px;
}

.center {
  text-align: center;
}

img.creator {
  border-radius: 50%;
}

img.alpha {
  opacity: 0.6;
  transition: opacity 0.3s;
}

img.alpha:hover {
  opacity: 1;
}

.bg-light-grey {
  background-color: #f6f6f6;
}

.bg-light-blue {
  background-color: #f8f9fc;
}

.btn-primary {
  background-color: #272b3d;
  border-color: #272b3d;
}

.btn-primary:hover {
  background-color: #5ac8fa;
  border-color: #5ac8fa;
}

.btn-secondary {
  background-color: #94d4fa;
  border-color: #94d4fa;
}

.btn-secondary:hover {
  background-color: #5ac8fa;
  border-color: #5ac8fa;
}

.btn-l {
  font-size: 1rem;
  padding: 0.5rem 1.5rem;
}

.btn-xl {
  font-size: 1.25rem;
  padding: 0.5rem 1.5rem;
}

.btn.rounded {
  border-radius: 25px !important;
}

.top-search {
  border: none;
  background: #f8f9fc;
  padding: 0.5rem 1rem;
  padding-right: 2.5rem;
  border-radius: 20px;
  width: 200px;
  transition: width 0.2s;
}
.top-search::placeholder {
  color: #272b3d;
  opacity: 0.5;
}
.top-search:active, .top-search:focus {
  width: 400px;
  outline: none;
  border: 2px solid #5ac8fa;
}

.search-icon {
  position: absolute;
  right: 1rem;
  top: 50%;
  transform: translateY(-50%);
  pointer-events: none;
  opacity: 0.5;
}

.mt-2 { margin-top: 2rem; }
.mt-4 { margin-top: 4rem; }
.mt-6 { margin-top: 6rem; }
.mt-8 { margin-top: 8rem; }
.mb-2 { margin-bottom: 2rem; }
.mb-4 { margin-bottom: 4rem; }
.mb-6 { margin-bottom: 6rem; }
.mb-8 { margin-bottom: 8rem; }
.my-2 { margin-top: 2rem; margin-bottom: 2rem; }
.my-4 { margin-top: 4rem; margin-bottom: 4rem; }
.my-6 { margin-top: 6rem; margin-bottom: 6rem; }
.my-8 { margin-top: 8rem; margin-bottom: 8rem; }
.pt-2 { padding-top: 2rem; }
.pt-4 { padding-top: 4rem; }
.pt-6 { padding-top: 6rem; }
.pt-8 { padding-top: 8rem; }
.pb-2 { padding-bottom: 2rem; }
.pb-4 { padding-bottom: 4rem; }
.pb-6 { padding-bottom: 6rem; }
.pb-8 { padding-bottom: 8rem; }
.py-2 { padding-top: 2rem; padding-bottom: 2rem; }
.py-4 { padding-top: 4rem; padding-bottom: 4rem; }
.py-6 { padding-top: 6rem; padding-bottom: 6rem; }
.py-8 { padding-top: 8rem; padding-bottom: 8rem; }
.mx-0 { margin-left: 0; margin-right: 0; }
.px-0 { padding-left: 0; padding-right: 0; }

@media (max-width: 960px) {
  /* , .hero .room-image img */
  .hero .room-image {
    height: 400px !important;
  }
  .hero img.creator {
    width: 85px !important;
    margin-left: 30px !important;
    margin-bottom: 30px !important;
  }
  .hero img.edge {
    width: 95px !important;
  }
}

  /* BEV Styles */
  body.fullscreen-active {
    padding: 0;
    overflow: hidden;
  }
  
  .container {
    xxxpadding: inherit;
  }
  
  .viewer-container {
    position: relative;
    width: 100%;
    height: 50vh;
    display: flex;
    justify-content: center;
    align-items: center;
    overflow: hidden;
    border-radius: 15px;
    margin-left: auto;
    margin-right: auto;
    padding-left: 0;
    padding-right: 0;
    padding: 0;
    max-width: 100%;
  }
  
  .viewer-outer-container {
    padding: 0 60px 0 60px;
    width: 100%;
    max-width: 100%;
    /* align center */
    margin-left: auto;
    margin-right: auto;
    position: relative;
    margin-bottom: 90px;
  }
  
  .viewer-outer-container .edge {
    position: absolute;
    left: 60px;
    bottom: 0;
  }
  
  .viewer-outer-container .creator {
    position: absolute;
    left: 30px;
    bottom: -30px;
  }
  
  @media (min-width: 1060px) {
    .viewer-outer-container {
      max-width: 1320px;
      padding: 0 50px 0 50px;
    }
    .viewer-outer-container .edge {
      left: 50px;
    }
    .viewer-outer-container .creator {
      left: 20px;
    }
    body.fullscreen-active .viewer-outer-container {
      max-width: 100%;
    }
  }
  .image-viewer {
    width: 100%;
    height: 100%;
    overflow: hidden;
    position: relative;
    background-color: #000;
  }
  
  .image-container {
    position: absolute;
    transform-origin: 0 0;
    width: 100%;
    height: 100%;
  }
  
  .image-wrapper {
    width: 100%;
    height: 100%;
    overflow: hidden;
    position: relative;
    touch-action: none;
  }
  
  #viewer-image {
    position: absolute;
    transform-origin: 0 0;
    user-select: none;
    -webkit-user-drag: none;
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
  
  .product-overlay {
    position: absolute;
    z-index: 10;
  }
  
  /* Overlays container */
  .overlays {
    position: absolute;
    top: 0;
    left: 0;
    pointer-events: none; /* Allow interactions to pass through to the image */
    z-index: 5;
    transform-origin: 0 0;
    will-change: transform;
    /* Width and height will be set dynamically in JavaScript to match image dimensions */
  }
  
  /* Individual overlay */
  .overlay {
    position: absolute;
    transform-origin: center;
    pointer-events: auto; /* Change to auto to enable mouse interaction */
    /* Use percentage positions to place overlays relative to the image size */
    opacity: 0.5;
    transition: opacity 0.3s;
    cursor: pointer;
    margin-left: 50px;
    margin-top: 50px;
  }
  
  .overlay:hover {
    opacity: 1;
  }
  
  .overlay img {
    max-width: 100%;
    height: auto;
  }
  
  /* Remove tooltip styling */
  .tooltip-container {
    display: none;
  }
  
  /* Seeker box styling */
  .seeker-box {
    position: fixed;
    width: 210px;
    height: 90px;
    border: 4px solid white;
    border-radius: 12px;
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.5);
    display: flex;
    opacity: 0;
    visibility: hidden;
    pointer-events: none;
    z-index: 2001; /* High z-index to ensure visibility */
    transition: opacity 0.3s, visibility 0.3s, transform 0.2s;
    transform: scale(0.8);
    transform-origin: 45px 45px;
  }
  
  /* Additional rule for fullscreen mode */
  .fullscreen-active .seeker-box {
    z-index: 10000; /* Even higher z-index in fullscreen mode */
  }
  
  .seeker-left {
    width: 82px;
    height: 820px;
    background-color: transparent;
    /* Left side transparent to show the overlay */
  }
  
  .seeker-right {
    width: 120px;
    height: 82px;
    background-color: white;
    padding: 10px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }
  
  .seeker-title {
    font-size: 12px;
    font-weight: bold;
    margin-bottom: 0;
    color: #333;
  }
  
  .seeker-price {
    font-size: 11px;
    color: #666;
    align-self: flex-start;
  }
  
  .seeker-visible {
    opacity: 1;
    visibility: visible;
    transform: scale(1);
    transform-origin: 45px 45px;
  }
  
  .controls {
    position: absolute;
    bottom: 20px;
    right: 20px;
    z-index: 10;
    display: flex;
    flex-direction: column;
    gap: 10px;
  }
  
  .control-btn {
    width: 40px;
    height: 40px;
    border-radius: 50%;
    background-color: rgba(255, 255, 255, 0.5);
    border: none;
    cursor: pointer;
    display: flex;
    justify-content: center;
    align-items: center;
    transition: background-color 0.3s;
    z-index: 20;
  }
  
  .control-btn:hover {
    background-color: rgba(255, 255, 255, 0.7);
  }
  
  .control-btn img {
    width: 24px;
    height: 24px;
  }
  
  .hidden {
    display: none;
  }
  
  .xxxfullscreen {
    position: fixed !important;
    top: 0 !important;
    left: 0 !important;
    width: 100vw !important;
    height: 100vh !important;
    z-index: 2000 !important;
    background-color: black;
    border-radius: 0 !important;
    box-shadow: none !important;
    margin: 0 !important;
    padding: 0 !important;
    max-width: none !important;
  }
  
  body.fullscreen-active {
    overflow: hidden;
  }
  
  /* Media query for mobile screens */
  @media (max-width: 768px) {
    body {
      xxpadding: 10px;
    }
    .navbar-brand img {
      height: 36px;
    }
    .viewer-container {
      height: 50vh;
      xxxwidth: 95%;
    }
    .control-btn {
      width: 36px;
      height: 36px;
    }
    .control-btn img {
      width: 20px;
      height: 20px;
    }
    .viewer-outer-container {
      padding: 0 40px 0 40px;
      margin-bottom: 30px;
    }
    .viewer-outer-container .edge {
      width: 75px;
      left: 40px;
    }
    .viewer-outer-container .creator {
      width: 72px;
      left: 22px;
      bottom: -16px;
    }
    .fullscreen {
      height: 100vh !important; /* Force full height in mobile */
      width: 100vw !important;
      margin: 0 !important;
      padding: 0 !important;
    }
    /* Move controls up on mobile to avoid being hidden by browser UI */
    .fullscreen .controls {
      bottom: 80px; /* Position higher up from the bottom */
    }
  }
  /* Special handling for iOS devices */
  @supports (-webkit-touch-callout: none) {
    /* iOS specific styles */
    .fullscreen .controls {
      bottom: 100px; /* Even higher for iOS devices */
    }
  }
  /* Radar Animation */
  .svg-area {
    display: block;
    margin: 0 auto 1rem;
  }
  
  #core {
    fill: #ffffff;
    animation: pulse1 3s ease-in-out infinite;
  }
  
  #radar {
    fill: rgba(255, 255, 255, 0.5);
    animation: pulse2 3s ease-in-out infinite;
  }
  
  @keyframes pulse1 {
    0% {
      opacity: 0;
      transform: scale(0);
    }
    20% {
      opacity: 1;
      transform: scale(1.5);
    }
    40% {
      opacity: 1;
      transform: scale(2);
    }
    60% {
      opacity: 0;
      transform: scale(2);
    }
    100% {
      opacity: 0;
      transform: scale(2);
    }
  }
  @keyframes pulse2 {
    0% {
      transform: scale(1, 1);
      opacity: 0;
    }
    30% {
      opacity: 1;
    }
    60% {
      transform: scale(6, 6);
      opacity: 0;
    }
    100% {
      transform: scale(6, 6);
      opacity: 0;
    }
  }
  /* Center CTA button on mobile screens */
  @media (max-width: 767.98px) {
    #cta-button {
      display: block;
      margin-left: auto;
      margin-right: auto;
      width: fit-content;
    }
  }

</style>
